import { BangCanDoiPhatSinhCongNoProvider, useBangCanDoiPhatSinhCongNoContext } from './context';
import InitialSearchDialog from './components/InitialSearchDialog';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { EditPrintTemplateDialog } from './components';
import { getTableColumns } from './cols-definition';
import ActionBar from './components/ActionBar';

function DebtBalanceReportPageContent() {
  const {
    isExporting,

    isLoading,
    data,
    currentPage,
    handlePageChange,
    totalItems,

    searchFieldStates,

    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    handleFixedColumnsClick,
    handleExportDataClick,

    selectedRowIndex,
    handleRowClick,

    searchState,
    handleSearchChange,
    handleSearchPageChange,
    hasFilterParams,
    handleInitialSearchLogic,
    handleRefreshClickLogic,
    isSearching
  } = useBangCanDoiPhatSinhCongNoContext();

  const handleInitialSearch = async (formData: BanHangPayload) => {
    try {
      await handleInitialSearchLogic(formData);
    } catch (error) {
      return;
    }
  };

  const handleRefreshClick = async () => {
    await handleRefreshClickLogic();
  };

  const handleCellClick = (row: BanHangRecord) => {
    const customerUuid = row.ma_kh_uuid || row.kh_uuid || row.ma_kh;
    if (!customerUuid) {
      return;
    }

    const accountUuid = row.tk_uuid || row.tk;
    if (!accountUuid) {
      return;
    }

    const dataToSave = {
      ngay_ct1: searchParams?.ngay_ct1,
      ngay_ct2: searchParams?.ngay_ct2,
      kieu_xem: searchParams?.kieu_xem ?? 1,
      group_by: searchParams?.group_by,
      mau_bc: searchParams?.mau_bc ?? 20,
      tk: accountUuid,
      ma_kh: customerUuid,
      kh_data: {
        uuid: customerUuid,
        customer_code: row.ma_kh,
        customer_name: row.ten_kh
      },
      tk_data: {
        uuid: accountUuid,
        code: row.tk,
        name: row.ten_tk
      }
    };
    localStorage.setItem('bang-can-doi-phat-sinh-cong-no-payload', JSON.stringify(dataToSave));

    const url = `/ban-hang/cong-no-khach-hang/so-chi-tiet-cong-no-theo-khach-hang/?ma_kh=${customerUuid}`;
    window.open(url, '_blank');
  };

  const tables = [
    {
      name: '',
      rows: (hasFilterParams ? searchState.searchResults : data) || [],
      columns: getTableColumns(handleCellClick)
    }
  ];

  return (
    <div className='flex h-screen w-full flex-col overflow-hidden'>
      {initialSearchDialogOpen && (
        <InitialSearchDialog
          open={initialSearchDialogOpen}
          onClose={handleInitialSearchClose}
          onSearch={handleInitialSearch}
          searchFieldStates={searchFieldStates}
          searchParams={searchParams}
        />
      )}
      <EditPrintTemplateDialog
        open={editPrintTemplateDialogOpen}
        onClose={handleClosePrintTemplateDialog}
        onSave={handleSavePrintTemplate}
      />

      {showTable && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onPrintClick={() => {}}
            onRefreshClick={handleRefreshClick}
            onFixedColumnsClick={handleFixedColumnsClick}
            onExportDataClick={handleExportDataClick}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            searchParams={searchParams}
            account={searchFieldStates.account}
          />

          <div className='w-full overflow-hidden'>
            {!isLoading && (
              <ErpDataTableV2
                tables={tables}
                onRowClick={handleRowClick}
                selectedRowId={selectedRowIndex || undefined}
                totalItems={hasFilterParams ? searchState.totalCount : totalItems}
                pageSize={50}
                currentPage={hasFilterParams ? searchState.currentPage : currentPage}
                onPageChange={hasFilterParams ? handleSearchPageChange : handlePageChange}
                onSearchChange={handleSearchChange}
                loading={isLoading}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default function DebtBalanceReportPage() {
  return (
    <BangCanDoiPhatSinhCongNoProvider>
      <DebtBalanceReportPageContent />
    </BangCanDoiPhatSinhCongNoProvider>
  );
}
